import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import Form from "components/react-validation/components/form";
import Input from "components/react-validation/components/input";
import Submit from "components/react-validation/components/submit";
import * as Vali from "helper/validator-helper";
import "../change-password.scss"; // CSS for right-side slide in

export class ChangePasswordModalHO extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    onChangePassword: PropTypes.func,
    errorMsg: PropTypes.array,
    item: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  onSubmit = (e) => {
    e.preventDefault();
    const valueForm = this.formChangePassword.getValues();
    if (!valueForm["newPassword"]) {
      this.formChangePassword.resetField(this.refs, "newPassword");
      this.formChangePassword.showError(
        this.refs["newPassword"],
        "This field is required"
      );
      this.formChangePassword.resetField(this.refs, "confirmNewPassword");
      this.formChangePassword.showError(
        this.refs["confirmNewPassword"],
        "This field is required"
      );
    } else {
      this.props.onChangePassword(e, valueForm, this.onChangePasswordCallback);
    }
  };

  onChangePasswordCallback = (status, data) => {
    this.formChangePassword.showError(this.refs["currentPassword"], data[0]);
  };

  render() {
    return (
      <Modal
        show={this.props.isOpen}
        onHide={this.props.closeModal}
        backdrop="static"
        dialogClassName="slide-in-modal"
        className="modal-right"
      >
        <Form
          ref={(ref) => {
            this.formChangePassword = ref;
          }}
          onSubmit={() => false}
        >
          <Modal.Header className="modal-header-profile">
            <div className="modal-header">
              <i
                class="fa fa-chevron-left arrow-btn"
                aria-hidden="true"
                onClick={this.props.closeModal}
              >
                {" "}
              </i>

              <Modal.Title className="modal-title-custom">
                Change Password
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body className="modal-body-profile">
            <p className="text-muted">
              <p className="pass-req">Password requirements:</p>
              Length between 4 and 40 characters
              <br />
            </p>
            <div className="form-section">
              <div className="form-group">
                <Input
                  type="password"
                  ref="currentPassword"
                  label="Current Password"
                  name="currentPassword"
                  placeholder="Current Password"
                  className="form-control"
                  maxLength="40"
                  max="40"
                  min="4"
                  validations={[
                    Vali.required,
                    Vali.maxlength,
                    Vali.minlengthPass,
                  ]}
                />
              </div>

              <div className="form-group">
                <Input
                  type="password"
                  ref="newPassword"
                  name="newPassword"
                  label="New Password"
                  placeholder="Enter New Password"
                  className="form-control"
                  maxLength="40"
                  max="40"
                  min="4"
                  validations={[
                    Vali.required,
                    Vali.maxlength,
                    Vali.minlengthPass,
                  ]}
                />
              </div>

              <div className="form-group">
                <Input
                  type="password"
                  ref="confirmNewPassword"
                  name="confirmNewPassword"
                  label="Confirm New Password"
                  placeholder="Re-enter New Password"
                  className="form-control"
                  maxLength="40"
                  max="40"
                  min="4"
                  compare="newPassword"
                  errorMsg="Confirmed password does not match the password above"
                  validations={[Vali.required, Vali.maxlength, Vali.compare]}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer-profile">
            <Submit
              className="btn btn-primary btn-siteone update-button"
              onClick={this.onSubmit}
            >
              Update Password
              <i class="fa fa-check check-mark" aria-hidden="true"></i>
            </Submit>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default ChangePasswordModalHO;


// WEBPACK FOOTER //
// ./src/User/Components/change-password-modal-Ho.js